import { createMuiTheme } from '@material-ui/core/styles';

import { Configuration } from '../../../configs/Configuration';

const configColors = Configuration.getColors().colors;
export default createMuiTheme({
  palette:{
    primary: {500:`rgb(${configColors['--color_55']})`}
  },
  typography:{
    fontSize: 16
  },
  overrides: {
    MuiButton : {
      root : {
        textTransform: 'none',
      }
    }
  }
});
